import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApiInterceptorService } from './shared/services/api-interceptor.service';
import { BannerUnitModule } from 'abs-ngx-library/src/lib/banner-unit';
import { DealsCarouselModule } from 'abs-ngx-library/src/lib/deals-carousel';
import { GalleryPageModule } from './components/gallery-page/gallery-page.module';

@NgModule({
  declarations: [
    AppComponent,
    // LeftNavigationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GalleryPageModule,
    SharedModule,
    DealsCarouselModule,
    BannerUnitModule
  ],
  providers: [
    provideHttpClient(
      withInterceptors([ApiInterceptorService])
    ),
    Title,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule { }
